// Array of configuration objects for different modes

/**
 * Array of configuration objects for different modes.
 * Each configuration object defines static fields, dynamic editable fields, and default settings for a specific mode.
 * @type {Array<Object>}
 * @property {string} mode - The mode identifier.
 * @property {Object} staticFields - Fields that are static for the mode, with properties indicating if they are editable and their type.
 * @property {Array<string>} dynamicEditableFields - Names of fields that can be dynamically edited.
 * @property {boolean} defaultEditable - Indicates whether unspecified fields are editable by default.
 * @property {string} defaultType - The default data type for unspecified fields.
 * @category Components
 * @subcategory ContextMenu
 */
const config = [
  {
    mode: "xm-part",
    staticFields: {
      "Part Number": { editable: false, type: "text" },
      Manufacturer: { editable: false, type: "text" },
      "Form Factor": { editable: false, type: "text" },
      "Manufacturer Part Number": { editable: false, type: "text" },
      "Price (USD)": { editable: false, type: "number" },
    },
    dynamicEditableFields: ["Quantity", "Threshold"],
    defaultEditable: true,
    defaultType: "number",
  },
  {
    mode: "custom",
    staticFields: {
      "Part Number": { editable: true, type: "text" },
      Manufacturer: { editable: true, type: "text" },
      "Form Factor": { editable: true, type: "text" },
      "Manufacturer Part Number": { editable: true, type: "text" },
      "Price (USD)": { editable: false, type: "number" },
    },
    dynamicEditableFields: ["CustomField1", "CustomField2"],
    defaultEditable: true,
    defaultType: "number",
  },
  // Additional modes can be added here
];

// Function to get the appropriate config based on mode

/**
 * Retrieves the appropriate configuration object for the given mode.
 * If the mode is "user-cfg" or "cfg-part", it defaults to "custom".
 * If no specific configuration is found, it defaults to the "default" mode configuration.
 *
 * @param {string} mode - The mode identifier for which the configuration is requested.
 * @returns {Object} The configuration object for the specified mode, or the "default" mode configuration if not found.
 */
function getConfigForMode(mode) {
  mode === "user-cfg" || mode === "cfg-part" ? (mode = "custom") : mode;
  return (
    config.find((configObj) => configObj.mode === mode) ||
    config.find((configObj) => configObj.mode === "default")
  );
}

// Export both the config array and the function
export { config, getConfigForMode };
